// Connecting Claude: the consent page's request and answer, and the admin's
// list of connections on /account.
import type { ClaudeConnectionView, OAuthDecision, OAuthRequestView } from "@bibleunleashed/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, del, post } from "./api";

export function useOAuthRequest(token: string, enabled: boolean) {
  return useQuery({
    queryKey: ["oauth-request", token],
    queryFn: () => api<OAuthRequestView>(`/api/oauth/request/${encodeURIComponent(token)}`),
    enabled: enabled && Boolean(token),
    retry: false,
    staleTime: Infinity,
  });
}

/** Answer the request; the browser then follows `redirect` back to the client. */
export function useOAuthDecision(token: string) {
  return useMutation({
    mutationFn: (approve: boolean) => post<OAuthDecision>(`/api/oauth/request/${encodeURIComponent(token)}`, { approve }),
  });
}

const CONNECTIONS = ["oauth-connections"];

export function useConnections(enabled: boolean) {
  return useQuery({ queryKey: CONNECTIONS, queryFn: () => api<ClaudeConnectionView[]>("/api/oauth/connections"), enabled });
}

export function useDisconnect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => del<null>(`/api/oauth/connections/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: CONNECTIONS }),
  });
}
